export const socialMedias = {
  whatsapp: {
    name: 'WhatsApp',
    code: 'whatsapp'
  },
  instagram: {
    name: 'Instagram',
    code: 'instagram'
  },
  facebook: {
    name: 'Facebook',
    code: 'facebook'
  },
  twitter: {
    name: 'X/Twitter',
    code: 'twitter'
  },
  tiktok: {
    name: 'TikTok',
    code: 'tiktok'
  },
  youtube: {
    name: 'YouTube',
    code: 'youtube'
  },
  copy: {
    name: 'Salin Tautan',
    code: 'copy'
  }
}

export const socialMediaShareLinks = {
  whatsapp: {
    name: 'WhatsApp',
    link: 'https://wa.me/?text='
  }
}

export const getShareLinkSocialMediaUrl = (socialMedia, message) => {
  return `${socialMediaShareLinks[socialMedia].link}${encodeURIComponent(message)}`
}

export const getWhatsappChatUrl = (phone, message = '') => {
  const cleanPhone = String(phone).replace(/[^0-9]/g, '')

  if (!message) {
    return `https://wa.me/${cleanPhone}`
  }

  return `https://wa.me/${cleanPhone}?text=${encodeURIComponent(message)}`
}
